import React, { Component } from 'react';
import Script from 'react-load-script';
import $ from 'jquery';
import { Link } from 'react-router-dom';


class Footer extends Component {
    render() {

return (

<div>
<footer >
                <div className="container dtd-tp-brdr">
                		<p className="cpy-right-txt"><span>All Rights Reserved 2018, RAT Films</span>   |    <span>Terms & Conditions</span>    |    <span>Privacy Policy</span>
                		<span className="dev-team"><a href="https://webandcrafts.com/" target="_blank">webandcrafts.com</a></span></p>

                </div>
            </footer>
<script src="https://unpkg.com/react@15.3.2/dist/react.js"></script>
<script src="https://unpkg.com/react-dom@15.3.2/dist/react-dom.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/react-bootstrap/0.30.5/react-bootstrap.js"></script>
<script src="https://unpkg.com/babel-standalone@6.15.0/babel.min.js"></script>
<script>
       
    </script>


</div>
           





     
    );
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/footer.js